/**
 * Small inline icon rendered via CSS mask-image, so the parent's `color`
 * tints it. Use for decorative icons next to text (phone, address, etc).
 *
 * Mask approach (vs <img src>) is what lets `text-ink-muted` and
 * `hover:text-accent` actually re-colour the icon on the parent.
 */
export default function InlineIcon({
  src,
  size = 14,
  className = '',
}: {
  src: string
  size?: number
  className?: string
}) {
  return (
    <span
      aria-hidden
      className={`inline-block shrink-0 bg-current ${className}`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        maskImage: `url(${src})`,
        WebkitMaskImage: `url(${src})`,
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskPosition: 'center',
      }}
    />
  )
}
